export enum CommandType {
    VersionInfo,
    GetPublicKey,
    CreateStream,
    SendStreamBlock,
    DecryptKeys,
    SignStreams,
    SeekStreamBegin,
    GetNextStreamBlock,
    DisposeStream,
    GetStreamHash,
    OpenSession,
    CloseSession,
    CloseApplication,
    GetStreamSize,
}
